import { render, staticRenderFns } from "./ButtonSignIn.vue?vue&type=template&id=bff9d664&"
import script from "./ButtonSignIn.vue?vue&type=script&lang=js&"
export * from "./ButtonSignIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports